enum ForeignHealthInsuranceProcessStepEnum {
  RATER = 1, // Tarificacion
  COVERAGES = 2, // Coberturas
  DOCUMENTS = 3, // Documentos
  HOLDER = 4, // Tomador
  INSUREDS = 5, // Asegurados
  QUESTIONNAIRES = 6, // Cuestionarios
  PAYMENT = 7, // MediosPago
  SIGN = 8, // Firma
  EMISSION = 9 // Emision
}

export default ForeignHealthInsuranceProcessStepEnum
